module.exports = __webpack_public_path__ + "static/media/dollar-sign.44fd6802.svg";